import { render } from "./MainFooter.vue?vue&type=template&id=b2d42018&scoped=true"
const script = {}

import "./MainFooter.vue?vue&type=style&index=0&id=b2d42018&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d42018"]])

export default __exports__